import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import noTranslations from './locales/no.json';
import deTranslations from './locales/de.json';
import frTranslations from './locales/fr.json';
import svTranslations from './locales/sv.json';
import daTranslations from './locales/da.json';
import fiTranslations from './locales/fi.json';

const resources = {
  en: { translation: enTranslations },
  no: { translation: noTranslations },
  de: { translation: deTranslations },
  fr: { translation: frTranslations },
  sv: { translation: svTranslations },
  da: { translation: daTranslations },
  fi: { translation: fiTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: import.meta.env.DEV,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'crystal-haccp-language',
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;